export enum AppsPermissions {
    SuperAdmin = 1,
    Admin = 2,
    PIDReader = 3,
    PIDWriter = 4
}